import { render, staticRenderFns } from "./payrollfrm.vue?vue&type=template&id=7f923e13"
import script from "./payrollfrm.vue?vue&type=script&lang=js"
export * from "./payrollfrm.vue?vue&type=script&lang=js"
import style0 from "./payrollfrm.vue?vue&type=style&index=0&id=7f923e13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports